<template>
  <v-flex style="display: flex; border-bottom: 1px solid #eee" justify-start>
    <f-time :offset="event.timeOffset" style="width: 10%"></f-time>
    <v-tooltip top style="width: 10%">
      <v-icon slot="activator">donut_large</v-icon>
      <span>Technical Timeout</span>
    </v-tooltip>
    <div style="display: flex; flex-grow: 1; justify-content: center">
      <h3>Technical Timeout</h3>
    </div>
  </v-flex>
</template>

<script>
import Time from './Time'

export default {
  props: ['event'],

  components: {
    'f-time': Time,
  },
}
</script>




// WEBPACK FOOTER //
// src/components/MatchLive/PlayByPlay/TechnicalTimeout.vue